// extracted by mini-css-extract-plugin
export default {"GetStarted":"GetStarted_GetStarted__c57vm"};